import SystemCalls from "@pages/roboto-calls/components/system-calls/SystemCalls";

export const RobotoCallsRoutes = [
  {
    path: "",
    component: SystemCalls,
    exact: true
  }
]